import { useState, useMemo } from "react";
import { formatInTimeZone } from "date-fns-tz";
import { Box, Autocomplete, TextField, Typography } from "@mui/material";
import { RawTimeZone } from "@vvo/tzdb";
import { getUsedTzs } from "@/utils/calendarHelper";

const TimeZones = ({
  defaultTimeZone,
  onChange,
}: {
  defaultTimeZone: RawTimeZone;
  // eslint-disable-next-line no-unused-vars
  onChange: (zone: RawTimeZone) => void;
}) => {
  const [timeZone, setTimeZone] = useState<RawTimeZone>(defaultTimeZone);

  const timeZones = useMemo(() => {
    return getUsedTzs();
  }, []);

  const handleSelectTimezone = (value: RawTimeZone) => {
    setTimeZone(value);
    onChange(value);
  };

  return (
    <Autocomplete
      key={Date.now()}
      size="small"
      options={timeZones}
      getOptionLabel={(option: RawTimeZone) =>
        `${option.name} Time - ${formatInTimeZone(new Date(), option.name, "p")}`
      }
      fullWidth
      defaultValue={timeZone}
      onChange={(_: any, newValue: RawTimeZone) => {
        handleSelectTimezone(newValue);
      }}
      disableClearable
      isOptionEqualToValue={(t: RawTimeZone) => t.name === timeZone.name}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          key={option.name}
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            flexDirection: "row",
            gap: 1,
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ width: "80%" }}>
            <Typography variant="body2">
              <span style={{ fontFamily: "ABCDiaTypebold" }}>
                {option.name} Time
              </span>
            </Typography>
          </Box>
          <Typography
            variant="body2"
            sx={{
              justifySelf: "flex-end",
              width: "20%",
              textAlign: "right",
            }}
          >
            {formatInTimeZone(new Date(), option.name, "p")}
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Choose a Timezone"
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
            type: "search",
          }}
        />
      )}
    />
  );
};

export default TimeZones;
